import { NextEdge } from './edges/next-edge';
import { NoEdge } from './edges/no-edge';
import { YesEdge } from './edges/yes-edge';
import { CustomActionNode } from './nodes/action-node';
import { CustomConditionalNode } from './nodes/conditional-node';
import { CustomTimeDelayNode } from './nodes/time-delay-node';
import { CustomTriggerNode } from './nodes/trigger-node';

export const edgeTypes = {
  next: NextEdge,
  yes: YesEdge,
  no: NoEdge,
};

export const nodeTypes = {
  action: CustomActionNode,
  trigger: CustomTriggerNode,
  timeDelay: CustomTimeDelayNode,
  conditional: CustomConditionalNode,
};
